import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa6';
import { useNavigate, useParams } from 'react-router-dom';

import SubAbasFornecedores from './subabasFornecedores';
import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import CustomCol from '../../../../../components/CustomCol';
import CustomRow from '../../../../../components/CustomRow';
import Input from '../../../../../components/InputNew';
import SelectInput from '../../../../../components/InputNew/Select';
import StyledLink from '../../../../../components/Link';
import Log from '../../../../../components/Log/Log';
import SubAbas from '../../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import { getUser } from '../../../../../modules/contexts/Auth/RequireAuth';
import { useHierarquia } from '../../../../../services/enum/useHierarquia';
import { usePorte } from '../../../../../services/enum/usePorte';
import {
  getAllCnpjCnaes,
  getAllMunicipiosIbge,
  getAllNaturezasjuridicas,
  getFornecedor,
} from '../../../../../services/fornecedoresDAF/fornecedorService';
import httpClient, { isHttpError } from '../../../../../services/httpClient';
import {
  formatarCnpj,
  formatDate,
  sanitizarForm,
  useCalculaPercentualDisponivel,
  validarCnpj,
} from '../../../../../utils/functions';
import {
  swalSave,
  swalErro,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../../utils/swal';
import {
  CnpjCnae,
  MunicipioIbge,
  MunicipioOptions,
  NaturezaJuridica,
} from '../types';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;

const FornecedoresFicha: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  // Dados do módulo
  let logs = {};
  let subAbas = [];

  const hierarquiaOptions = useHierarquia();
  const porteOptions = usePorte();

  const [cnpjCnaeData, setCnpjCnaeData] = useState<CnpjCnae[]>([]);
  const [naturezaJuridicaData, setNaturezaJuridicaData] = useState<
    NaturezaJuridica[]
  >([]);
  const [municipioIbgeData, setMunicipioIbgeData] = useState<MunicipioIbge[]>(
    [],
  );
  const [ufIndex, setUfIndex] = useState<string>('0');
  const [municipioOptions, setMunicipioOptions] = useState<MunicipioOptions[]>(
    [],
  );

  const [data, setData] = useState<any>();

  const [formFornecedor, setFormFornecedor] = useState({
    cnpj: '',
    hierarquia: 0,
    porte: 0,
    dataAbertura: '',
    razaoSocial: '',
    nomeFantasia: '',
    telefone1: '',
    telefone2: '',
    email: '',
    site: '',
    cep: '',
    bairro: '',
    logradouro: '',
    numeroImovel: '',
    observacoes: '',

    // chaves estrangeiras
    cnpjCnaeId: 0,
    atividadePrincipal: 'Não informado',
    descAtividadePrincipal: 'Não informado',

    naturezaJuridicaId: 0,
    codigo: 'Não informado',
    tipoDireito: 'Não informado',
    descNaturezaJuridica: 'Não informado',

    municipioIbgeId: 0,
    ufSigla: '',
    municipio: '',

    // chave usuário
    usuarioRegistroId: userID,
  });

  const codigoOptions = [
    { value: 0, label: 'Não informado' },
    ...naturezaJuridicaData.map((item) => ({
      value: item.id,
      label: item.codigo,
    })),
  ];

  const atividadePrincipalOptions = [
    { value: 0, label: 'Não informado' },
    ...cnpjCnaeData.map((item) => ({
      value: item.id,
      label: item.subclasseCodigo,
    })),
  ];

  const ufOptions = [
    { value: 0, label: ' - ' },
    ...municipioIbgeData
      .filter(
        (item, index, self) =>
          // Filtra apenas os itens cujas labels são únicas
          index === self.findIndex((i) => i.ufSigla === item.ufSigla),
      )
      .sort((a, b) => a.ufSigla.localeCompare(b.ufSigla))
      .map((item, index) => ({
        value: index + 1,
        label: item.ufSigla,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
  ];

  // Buscar dados
  const fetchData = async (id: string) => {
    try {
      const fornecedorData = await getFornecedor(id);
      console.log(fornecedorData);
      setData(fornecedorData);
      setFormFornecedor({
        usuarioRegistroId: userID,
        hierarquia: fornecedorData.hierarquia,
        porte: fornecedorData.porte,
        cnpj: fornecedorData.cnpj,
        razaoSocial: fornecedorData.razaoSocial,
        nomeFantasia: fornecedorData.nomeFantasia,
        dataAbertura: fornecedorData.dataAbertura,
        telefone1: fornecedorData.telefone1,
        telefone2: fornecedorData.telefone2,
        email: fornecedorData.email,
        site: fornecedorData.site,
        cep: fornecedorData.cep,
        bairro: fornecedorData.bairro,
        logradouro: fornecedorData.logradouro,
        numeroImovel: fornecedorData.numeroImovel,
        observacoes: fornecedorData.observacoes,

        // CNPJ CNAE
        cnpjCnaeId: fornecedorData.cnpjCnae.id,
        atividadePrincipal: fornecedorData.cnpjCnae.subclasseCodigo,
        descAtividadePrincipal: fornecedorData.cnpjCnae.subclasseDescricao,

        // Natureza Jurídica
        naturezaJuridicaId: fornecedorData.naturezaJuridica.id,
        codigo: fornecedorData.naturezaJuridica.codigo,
        tipoDireito: fornecedorData.naturezaJuridica.tipo,
        descNaturezaJuridica: fornecedorData.naturezaJuridica.naturezaJuridica,

        // Municipio IBGE
        municipioIbgeId: fornecedorData.municipioIbge.id,
        ufSigla: fornecedorData.municipioIbge.ufSigla,
        municipio: fornecedorData.municipioIbge.municipio,
      });

      // handleMunicipioOptions(fornecedorData.municipioIbge.ufSigla);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  const fetchOptions = async () => {
    try {
      const cnpjCnaeData = await getAllCnpjCnaes();
      const naturezaJuridicaData = await getAllNaturezasjuridicas();
      const municipioIbgeData = await getAllMunicipiosIbge();
      setCnpjCnaeData(cnpjCnaeData);
      setNaturezaJuridicaData(naturezaJuridicaData);
      setMunicipioIbgeData(municipioIbgeData);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
    }
  };

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  useEffect(() => {
    fetchOptions();
    if (fichaID !== 'undefined') {
      // fetchOptions();
      fetchData(fichaID);
    }
  }, []);

  // useEffect para formatar o CNPJ após mudança
  useEffect(() => {
    if (formFornecedor.cnpj) {
      const cnpjFormatado = formatarCnpj(formFornecedor.cnpj);
      setFormFornecedor((prev) => ({
        ...prev,
        cnpj: cnpjFormatado,
      }));
    }
  }, [formFornecedor.cnpj]);

  // useEffect para validar CNPJ após mudança
  useEffect(() => {
    if (formFornecedor.cnpj && formFornecedor.cnpj.length === 18) {
      if (!validarCnpj(formFornecedor.cnpj)) {
        swalErro('CNPJ Inválido');
      }
    }
  }, [formFornecedor.cnpj]);

  // Função para buscar os municípios com base na UF selecionada
  useEffect(() => {
    const fetchMunicipiosByUf = async (ufSigla: string) => {
      if (ufSigla) {
        try {
          const municipioData = await getAllMunicipiosIbge();
          const filteredMunicipios = municipioData
            .filter((municipio) => municipio.ufSigla === ufSigla)
            .map((municipio) => ({
              value: municipio.id,
              label: municipio.municipio,
            }));

          setMunicipioOptions(filteredMunicipios);

          if (filteredMunicipios.length > 0) {
            setFormFornecedor((prev) => ({
              ...prev,
              municipioIbgeId: filteredMunicipios[0].value,
              municipio: filteredMunicipios[0].label,
            }));
          }
        } catch (error) {
          console.error('Erro ao obter municípios:', error);
        }
      }
    };

    fetchMunicipiosByUf(formFornecedor.ufSigla);
  }, [formFornecedor.ufSigla]);

  // useEffect para sincronizar uFIndex após os dados serem carregados
  useEffect(() => {
    if (formFornecedor.ufSigla && ufOptions.length > 0) {
      const matchingOption = ufOptions.find(
        (option) => option.label === formFornecedor.ufSigla,
      );

      if (matchingOption) {
        setUfIndex(matchingOption.value.toString());
      }
    }
  }, [formFornecedor.ufSigla, ufOptions]);

  // useEffect para atualizar descNaturezaJuridica e Tipo de Direito de acordo com o Id de Natureza Jurídica
  useEffect(() => {
    const fetchDescNaturezaJuridicaAndTipoDireitoByCodigo = async (
      codigo: string,
    ) => {
      if (codigo) {
        try {
          if (formFornecedor.descNaturezaJuridica && codigoOptions.length > 0) {
            const natJurData = await getAllNaturezasjuridicas();

            const matchingRecord = natJurData.find(
              (record) => record.id.toString() === codigo,
            );

            if (matchingRecord) {
              setFormFornecedor({
                ...formFornecedor,
                descNaturezaJuridica: matchingRecord.naturezaJuridica,
                tipoDireito: matchingRecord.tipo,
              });
            }
          }
        } catch (error) {
          console.error('Erro ao obter Natureza jurídica:', error);
        }
      }
    };
    fetchDescNaturezaJuridicaAndTipoDireitoByCodigo(formFornecedor.codigo);
  }, [formFornecedor.codigo]);

  // useEffect para atualizar descAtividadePrincipal de acordo com o valor de cnpjCnaeId
  useEffect(() => {
    const fetchDescAtividadePrincipalbyCnpjCnaeId = async (
      atividadePrincipal: string,
    ) => {
      if (atividadePrincipal) {
        try {
          if (
            formFornecedor.descAtividadePrincipal &&
            atividadePrincipalOptions.length > 0
          ) {
            const cnaeData = await getAllCnpjCnaes();

            const matchingRecord = cnaeData.find(
              (record) => record.id.toString() === atividadePrincipal,
            );

            if (matchingRecord) {
              setFormFornecedor({
                ...formFornecedor,
                descAtividadePrincipal: matchingRecord.subclasseDescricao,
              });
            }
          }
        } catch (error) {
          console.error('Erro ao obter Natureza jurídica:', error);
        }
      }
    };
    (setTimeout(() =>
      fetchDescAtividadePrincipalbyCnpjCnaeId(
        formFornecedor.atividadePrincipal,
      ),
    ),
      200);
  }, [formFornecedor.atividadePrincipal]);

  if (fichaID !== 'undefined') {
    if (data) {
      logs = {
        id: data.id,
        usuarioRegistro: data.usuarioRegistro.nomeCompleto,
        usuarioAtualizacao: data.usuarioAtualizacao.nomeCompleto,
        dataRegistro: data.dataRegistro,
        dataAtualizacao: data.dataUltimaAtualizacao,
        nEdicoes: data.nEdicoes,
      };
    }
    //Subabas
    subAbas = SubAbasFornecedores(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/fornecedor/fornecedores/fornecedores/ficha/dadosgerais`,
      },
    ];
  }

  // Manipulação de dados
  const handleChange = (event: any) => {
    const { name, value } = event.target;
    const newValue = parseInt(value, 10);
    if (name === 'uf') {
      const uf = ufOptions.find((option) => option.value.toString() === value);
      setUfIndex(value);
      if (uf) {
        setFormFornecedor({
          ...formFornecedor,
          ufSigla: uf.label,
        });
      }
    } else {
      if (name === 'codigo') {
        setFormFornecedor({
          ...formFornecedor,
          naturezaJuridicaId: newValue,
          codigo: value,
        });
      } else if (name === 'municipio') {
        setFormFornecedor({
          ...formFornecedor,
          municipioIbgeId: newValue,
          municipio: value,
        });
      } else if (name === 'atividadePrincipal') {
        setFormFornecedor({
          ...formFornecedor,
          cnpjCnaeId: newValue,
          atividadePrincipal: value,
        });
      } else if (name === 'cnpj') {
        const cnpjFormatado = formatarCnpj(value);
        setFormFornecedor((prev) => ({
          ...prev,
          cnpj: cnpjFormatado,
        }));
      } else {
        setFormFornecedor((prev) => ({
          ...prev,
          [name]: [
            'porte',
            'hierarquia',
            'naturezaJuridicaId',
            'municipioIbgeId',
            'cnpjCnaeId',
          ].includes(name)
            ? Number(value)
            : value,
        }));
      }
      // setFormFornecedor((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo

    if (!form.cnpj) {
      errors.push('<b>CNPJ</b> é obrigatório.');
    }

    if (!form.razaoSocial) {
      errors.push('<b>Razão Social</b> é obrigatório.');
    }

    if (!form.nomeFantasia) {
      errors.push('<b>Nome Fantasia</b> é obrigatório.');
    }

    if (!form.hierarquia) {
      errors.push('<b>Hierarquia</b> é obrigatório.');
    }

    if (!form.porte) {
      errors.push('<b>Porte</b> é obrigatório.');
    }

    if (!form.dataAbertura) {
      errors.push('<b>Data de Abertura</b> é obrigatório.');
    }

    if (!form.email) {
      errors.push('<b>Email</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  //Funções Handle
  const handleCreate = async () => {
    try {
      const formAjustado = {
        ...formFornecedor,
        dataAbertura: new Date(formatDate(formFornecedor.dataAbertura)),
      };

      const formToSend = sanitizarForm(formAjustado);
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formToSend);
      if (!isFormValid) return;

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/fornecedor`, formToSend);

      swalSave();
      setTimeout(
        () =>
          navigate(
            `/fornecedor/fornecedores/fornecedores/ficha/${response.data.fornecedor.id}/dadosgerais`,
          ),
        2500,
      );
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
    }
  };

  const handleUpdate = async () => {
    try {
      // const formAjustado = {
      //   ...formFornecedor,
      //   dataAbertura: new Date(formatDate(formFornecedor.dataAbertura)),
      // };

      const formToSend = sanitizarForm(formFornecedor);
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formToSend);
      if (!isFormValid) return;

      const response = await httpClient.patch(
        `/api/fornecedor/${fichaID}`,
        formFornecedor,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registroAtualizado.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(`/api/fornecedor/${fichaID}`);
        swalDeleteConfirm();
        navigate('/fornecedor/fornecedores/fornecedores');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  //Adicionais
  const larguraDisponivel = useCalculaPercentualDisponivel(
    '100px',
    '300px',
    '300px',
    '300px',
  );
  const larguraDisponivel2 = useCalculaPercentualDisponivel('220px');

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/fornecedor/adm/fornecedores"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            // backgroundColor: '#E1ECFE',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          <BoxConteudo boxTitulo="Dados do Fornecedor">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="205px">
                <Input
                  id="cnpj"
                  name="cnpj"
                  value={formFornecedor.cnpj}
                  label="CNPJ"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="dataAbertura"
                  name="dataAbertura"
                  type="date"
                  value={formFornecedor.dataAbertura}
                  onChange={handleChange}
                  readonly={false}
                  label="Data de Abertura"
                />
              </CustomCol>
              <CustomCol width="190px">
                <SelectInput
                  name="hierarquia"
                  options={hierarquiaOptions}
                  label="Hierarquia"
                  value={formFornecedor.hierarquia}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="porte"
                  options={porteOptions}
                  label="Porte"
                  value={formFornecedor.porte}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width={larguraDisponivel}>
                <Input
                  id="tipoDireito"
                  name="tipoDeDireito"
                  value={formFornecedor.tipoDireito}
                  label="Tipo de Direito"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="200px">
                <SelectInput
                  name="codigo"
                  options={codigoOptions}
                  label="Nat. Jurídica"
                  value={formFornecedor.naturezaJuridicaId}
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width={larguraDisponivel2}>
                <Input
                  id="naturezaJuridica"
                  name="naturezaJuridica"
                  value={formFornecedor.descNaturezaJuridica}
                  label="Descrição da Natureza Jurídica"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
            </CustomRow>

            <CustomRow>
              <CustomCol width="100%">
                <Input
                  id="razaoSocial"
                  name="razaoSocial"
                  value={formFornecedor.razaoSocial}
                  label="Razão Social"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="100%">
                <Input
                  id="nomeFantasia"
                  name="nomeFantasia"
                  value={formFornecedor.nomeFantasia}
                  label="Nome Fantasia"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Atividade Empresarial">
            <CustomRow style={{ marginTop: '-15px' }}>
              <Col md="2">
                <SelectInput
                  name="atividadePrincipal"
                  options={atividadePrincipalOptions}
                  label="Atividade Principal"
                  value={formFornecedor.cnpjCnaeId}
                  onChange={handleChange}
                />
              </Col>
              <Col>
                <Input
                  id="descAtividadePrincipal"
                  name="descAtividadePrincipal"
                  value={formFornecedor.descAtividadePrincipal}
                  label="Descrição da Atividade Principal"
                  onChange={handleChange}
                  readonly
                />
              </Col>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Contato Institucional">
            <CustomRow style={{ marginTop: '-15px' }}>
              <Col md="2">
                <Input
                  id="telefone1"
                  mascara="telefone"
                  name="telefone1"
                  value={formFornecedor.telefone1}
                  label="Telefone 1"
                  onChange={handleChange}
                />
              </Col>
              <Col md="2">
                <Input
                  id="telefone2"
                  name="telefone2"
                  mascara="telefone"
                  value={formFornecedor.telefone2}
                  label="Telefone 2"
                  onChange={handleChange}
                />
              </Col>
              <Col sm="12" md="4">
                <Input
                  id="email"
                  name="email"
                  value={formFornecedor.email}
                  label="Email"
                  onChange={handleChange}
                  required
                />
              </Col>
              <Col sm="12" md="4">
                <Input
                  id="site"
                  name="site"
                  value={formFornecedor.site}
                  label="Site"
                  onChange={handleChange}
                />
              </Col>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Endereço">
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="12%">
                <Input
                  id="cep"
                  name="cep"
                  mascara="cep"
                  value={formFornecedor.cep}
                  label="CEP"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="8%">
                <SelectInput
                  name="uf"
                  options={ufOptions}
                  label="UF"
                  value={ufIndex}
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="40%">
                <SelectInput
                  name="municipio"
                  options={municipioOptions}
                  label="Município"
                  value={formFornecedor.municipioIbgeId}
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="40%">
                <Input
                  id="bairro"
                  name="bairro"
                  value={formFornecedor.bairro}
                  label="Bairro"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="85%">
                <Input
                  id="logradouro"
                  name="logradouro"
                  value={formFornecedor.logradouro}
                  label="Logradouro"
                  onChange={handleChange}
                />
              </CustomCol>
              <CustomCol width="15%">
                <Input
                  id="numeroImovel"
                  name="numeroImovel"
                  value={formFornecedor.numeroImovel}
                  label="Número"
                  onChange={handleChange}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Observações Gerais" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <Col>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  linhas={5}
                  value={formFornecedor.observacoes}
                  onChange={handleChange}
                />
              </Col>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
};

export default FornecedoresFicha;
